@if (shippingMethods.length > 0) {
<div class="shipping-menu-wrapper" [style.max-width.px]="maxWidth">
  <div (click)="menu.toggle($event)" pRipple class="shipping-selector" [class.light]="darkMode">
    <div class="image-wrapper">
      <img class="shipping-image" src="./../../../../../assets/images/product/shipping/container.svg"
        alt="express-shipping">
    </div>
    <div class="option-content">
      <div class="shipping-info">
        <div class="shipping-name">
          @if (!smallLabel) {
          <span>Express shipping</span>
          }
          @if (smallLabel) {
          <span>Express</span>
          }
        </div>
      </div>
      <div class="right">
        <div class="shipping-price">
          <span>{{1000 | number}} kr</span>
        </div>
        <img class="selector-arrow" src="./../../../assets/images/product/shipping/arrow_drop_down.svg"
          alt="selector-arrow">
      </div>
    </div>
  </div>
  <p-menu #menu class="custom-dropdown-menu" [model]="shippingMethods" [popup]="true" [appendTo]="appendTo">
    <ng-template pTemplate="item" let-item>
      <a class="p-menuitem-link flex justify-content-between align-items-center p-3">
        <div>
          <span [class]="item.icon"></span>
          <span> {{ item.label }}</span>
        </div>
        <div>
          @if (item.shortcut) {
          <span [class]="item.shortcutClass">{{ item.shortcut }}</span>
          }
        </div>
      </a>
    </ng-template>
  </p-menu>
</div>
} @else {
<div class="shipping-menu-wrapper" [style.max-width.px]="maxWidth">
  <div pRipple class="shipping-selector" [class.light]="darkMode">
    <div class="image-wrapper">
      <img class="shipping-image" src="./../../../../../assets/images/product/shipping/container.svg"
        alt="express-shipping">
    </div>
    <div class="option-content">
      <div class="shipping-info">
        <div class="shipping-name">
          @if (!smallLabel) {
          <span>Free shipping</span>
          }
          @if (smallLabel) {
          <span>Free</span>
          }
        </div>

        <div class="shipping-time">
          <span>2-4 weeks</span>
        </div>

      </div>

      <div class="right">
        <div class="shipping-price">
          <span>{{0 | number}} kr</span>
        </div>
      </div>

    </div>
  </div>
</div>
}
